var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobUnderInspectionLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 13.3334V6.91675L3.5 5.16675V1.66675H10.5V5.16675L9.33333 6.91675V13.3334H4.66667ZM7 9.54175C6.75694 9.54175 6.55035 9.45668 6.38021 9.28654C6.21007 9.1164 6.125 8.9098 6.125 8.66675C6.125 8.42369 6.21007 8.21709 6.38021 8.04696C6.55035 7.87682 6.75694 7.79175 7 7.79175C7.24306 7.79175 7.44965 7.87682 7.61979 8.04696C7.78993 8.21709 7.875 8.42369 7.875 8.66675C7.875 8.9098 7.78993 9.1164 7.61979 9.28654C7.44965 9.45668 7.24306 9.54175 7 9.54175ZM4.66667 3.41675H9.33333V2.83341H4.66667V3.41675ZM9.33333 4.58341H4.66667V4.81675L5.83333 6.56675V12.1667H8.16667V6.56675L9.33333 4.81675V4.58341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobUnderInspectionLegend);
export default __webpack_public_path__ + "static/media/job-under-inspection-legend.a535e4e28f0eb1b6268947397decfa50.svg";
export { ForwardRef as ReactComponent };